import React from "react";
import { Refund } from "../../components/refund/refund.component";

export const RefundPage = () => {
  return <Refund />;
};
